import React from 'react';
import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchemaPl from './stepsSchemaPl';
import stepsSchemaCz from './stepsSchemaCz';
import { DIET_MODES, DIET_TYPES_PL, DIET_TYPES_CZ, DIET_LEVELS } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const routes: Route[] = [
  {
    path: '/diet-settings/all/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={activeLang === 'pl-PL' ? stepsSchemaPl : stepsSchemaCz}
        currentMainStep="all"
        dietTypes={activeLang === 'pl-PL' ? DIET_TYPES_PL : DIET_TYPES_CZ}
        dietLevels={activeLang === 'pl-PL' ? DIET_LEVELS : undefined}
        dietModes={DIET_MODES}
      />
    ),
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
